import { render, staticRenderFns } from "./ZLquery.vue?vue&type=template&id=72fc8ad8&scoped=true"
import script from "./ZLquery.vue?vue&type=script&lang=js"
export * from "./ZLquery.vue?vue&type=script&lang=js"
import style0 from "./ZLquery.vue?vue&type=style&index=0&id=72fc8ad8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fc8ad8",
  null
  
)

export default component.exports